const listPointsBody = document.querySelector('#filmAFConsider').querySelector('div[name=body]');
const btnewMsgChat = document.querySelector('#filmAFConsider').querySelector('button[name=lookMsg]');
const btnewMsgNewLinks = document.querySelector('#filmAFConsider').querySelector('button[name=lookNewLinks]');


const universalViewSearchFiled = document.querySelector('#filmAFConsider').querySelector('input[name=search]');
const typeSort = document.querySelector('#filmAFConsider').querySelector('button[name=typeDataSort]')
// import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';
import auth from '../tools/storage.js';
import tools from '../tools/tools.js';


const mypopup = document.getElementById("mypopup");


export default {

  cleanContainer() {
    listPointsBody.innerHTML = '';
  },

  getElement(item, index, newMsg, newCmt , curUserReviewer, countUserReviewer, newVideo) {
    let groupClass = ' ';

    let fcID = ` fCID=${item.considerID} numReq=${item.numRequest} `;
    if(item.localgroup == 1)
      groupClass = 'groupsOfConsider_1';
    else  if(item.localgroup == 2)
      groupClass = 'groupsOfConsider_2';
    else  if(item.localgroup == 3)
      groupClass = 'groupsOfConsider_3';
    
    let commentHTML = ` <div ${fcID} class = "lastCommentEmpty" ></div>`;
    if(item.comment)
      commentHTML = ` <div ${fcID} class="lastComment popup" popupShift="100"  popupAlert="${item.comment}" popupMsg="${item.maxTimeComment}">${item.comment}</div>`;


    let lastMsg = '';
    if(item.lastchat) {
      let nameClassMsg = 'lastUserMsg';
      if(item.lastchatUser && parseInt(item.lastchatUser) == 11)
        nameClassMsg = 'lastSysMsg'
      if(item.lastChatManager)
        nameClassMsg = 'lastManagerMsg';
      lastMsg = ` <div ${fcID}   lastMsg="last" class="${nameClassMsg} popup" popupShift="150" popupAlert="${item.lastchat}" popupMsg="${item.maxTimeChat}">${item.lastchat}</div>`;
    }


    let reviewAnswer = '';
    let classNametype = '';
    let review_value = parseInt(item.reviewValue, 10);
    // console.log(item.reviewValue);
    if(parseInt(item.reviewValue, 10) === 1){
      classNametype = 'review_reject';
      reviewAnswer = 'Отказ';
    } else if (parseInt(item.reviewValue, 10) === 2){
      classNametype = 'review_wait';
      reviewAnswer = 'Ожидаю ответ';
    } else if (parseInt(item.reviewValue, 10) === 3){
      classNametype = 'review_wait';
      reviewAnswer = 'Есть замечания';
    } else if (parseInt(item.reviewValue, 10) === 4){
      classNametype = 'review_wait';
      reviewAnswer = 'Думаю';
    } else if (parseInt(item.reviewValue, 10) === 5){
      classNametype = 'review_agree';
      reviewAnswer = 'Одобряю';
    } else if (curUserReviewer) {
      classNametype = 'review_none';
      reviewAnswer = 'Нет оценки';
      review_value = 0;
    }

    let reviewStatus = '';
    if(classNametype.length>1)
      reviewStatus = `<small ${fcID}  class="review_cloud_preview ${classNametype}"  review_value = ${review_value}>${reviewAnswer}</small>`;

    let premiereStatus = '';
    
    if(parseInt(item.premiere, 10) === 1)
      premiereStatus = `<div class = "premiere-icon popup premiere-icon-russia"  popupAlert="Российская премьера" ></div>`;
    else   if(parseInt(item.premiere, 10) === 2)
      premiereStatus = `<div class = "premiere-icon popup premiere-icon-world"  popupAlert="Мировая премьера"></div>`;
    
    let newMsgIcon = '';
    if(newMsg)
      newMsgIcon = `<div class = "premiere-icon  popup icon-newMsg"  popupAlert="Новое сообщение от заявителя" ></div>`;
    
    
    let newCmtIcon = '';
    if(newCmt)
      newCmtIcon = `<div class = "premiere-icon  popup icon-newCmt"  popupAlert="Новая заметка" ></div>`;

    let newVideoIcon = '';
    if (newVideo)
      newVideoIcon = `<div class = "premiere-icon  popup icon-newAttach"  popupAlert="Заявитель обновил ссылку!" popupMsg="Shift + click = убрать данное уведомление"  alertNewLinkForfCID=${item.considerID} ></div>`;


    let reviewReady = '';

    let arrVotes = [];
        
    if(item.lineVotes){
      arrVotes = item.lineVotes.toString().split(',');
      if(arrVotes)
        arrVotes.forEach(voteInServer => {
          let voteInfo = voteInServer.split('-');
          reviewReady += `<div ${fcID} class="iconReviewPoint popup reviewPoint${voteInfo[0]}" popupAlert="${voteInfo[1]}"> </div>`;
        });
    }
    if (item.countReview && parseInt(item.countReview, 10) > 0) {
      if(countUserReviewer === parseInt(item.countReview, 10))
        reviewReady = `<div ${fcID}  class = "iconReviewReadyAll "></div>`;
      // else if(countUserReviewer > parseInt(item.countReview, 10)){
  
      // }
        // reviewReady = `<div ${fcID}  class = "iconReviewReadyNotAll">${item.countReview}/${countUserReviewer}</div>`; 

    }
   
    return `<div class="reference-header  m-0 p-1 " ${fcID}> 
            <div  class="reference-column m-0 p-0"> 
              <label ${fcID}  class=" p-0 m-0 iconGroupOfConsider ${groupClass}">${item.numRequest}</label>
            </div>  
            <label ${fcID}  class="reference-column m-0 p-0 pl-1">${item.name} ${premiereStatus} ${newMsgIcon} ${newCmtIcon} ${newVideoIcon}<p class="ml-auto mr-auto"></p> ${reviewReady} ${reviewStatus} </label>
            <label ${fcID} class="columnLightPink m-0 p-0" style="max-width: 17%; min-width: 17%;"> ${commentHTML} </label>
            <label ${fcID} class="columnLightPink m-0 p-0" style="max-width: 19%; min-width: 19%;" lastMsg="last"   > ${lastMsg} </label>
          </div>`;
  },


  addDataRejectedInContainer(listWithData) {

   let HTMLBODY = `<div class="column w-100">
                <h4>Работы, которые были отозваны заявителями:</h4>
              </div>`;


    listWithData.forEach((item, index) => {
      HTMLBODY += this.getElement(item, index, false, false, false, 0, false);
    });

    listPointsBody.innerHTML += HTMLBODY;

  },


  drawDataInContainer(listWithData, arrNotifications , arrcntUserReviewer, arrNotificationsVideo) {
    this.cleanContainer();
    let curUserReviewer = false;
    let HTMLBODY = '';
    if(!btnewMsgChat.classList.contains('activeBtn'))
      btnewMsgChat.disabled = true;

    if(!btnewMsgNewLinks.classList.contains('activeBtn'))
      btnewMsgNewLinks.disabled = true;


    let nomIDBefore = 0;
    let countUserReviewer = 0;
    let competitionBefore = 0;
    let countInGROUP = 0;
    // console.log(typeSort.value);

    if(listWithData) {


        if(typeSort.value == 5) { // перебор данных, чтобы перенести прочее(медиатеку) в конец списка
          let arrOtherApplications = [];
          let currentProgramMediateka = true;
          // let = indexDoWhile;
          let indexDoWhile = 0;

          do
          { 
            if(listWithData[0].competitionType === 2)
              arrOtherApplications.push(listWithData.shift());
            else
              currentProgramMediateka = false;

          } while(currentProgramMediateka && listWithData.length >0);

          listWithData = listWithData.concat(arrOtherApplications);
        }


      // console.log(arrcntUserReviewer);
      if(arrcntUserReviewer)
        arrcntUserReviewer.forEach((item, index) => {
          ++countUserReviewer;
          if(item === parseInt(auth.data.operatorId, 10))
            curUserReviewer = true;
          // console.log(item);
        });


      listPointsBody.classList.remove('row');
      listPointsBody.classList.remove('column');
      listPointsBody.classList.add('column');
      HTMLBODY = '';
      if (typeSort.value != 4 && typeSort.value != 5)
        HTMLBODY = `
            <div class="reference-header firstRow">
                <div class="reference-column">№</div>
                <div class="reference-column">Название работы + ваша личная оценка</div>
                <div class="reference-column " style="max-width: 18%; min-width: 18%;">Последняя заметка</div>
                <div class="reference-column " style="max-width: 18%; min-width: 18%;">Последнее сообщение</div>
            </div>
            `;
      listWithData.forEach((item, index) => {
        let newMsg = false;
        let newCmt = false;
        let newVideo = false;


        if (arrNotificationsVideo)
          arrNotificationsVideo.forEach((nItem,nIndex) => {

            if (parseInt(item.considerID, 10) === parseInt(nItem.considerID, 10)){
              btnewMsgNewLinks.disabled = false;
              newVideo = true;
            }
          });

        if (arrNotifications)
          arrNotifications.forEach((nItem,nIndex) => {
            if (parseInt(item.considerID, 10) === parseInt(nItem.considerIDNewMessage, 10)){
              if(universalViewSearchFiled.value.length == 0)
                btnewMsgChat.disabled = false;
              newMsg = true
            }
           
            if (parseInt(item.considerID, 10) === parseInt(nItem.considerIDNewComment, 10)){

              if(universalViewSearchFiled.value.length == 0)
                btnewMsgChat.disabled = false;
              newCmt = true;
            }
          });

        if (typeSort.value == 4 && (nomIDBefore!= item.nominationOrder)){
          if (countInGROUP > 0){
            HTMLBODY += `<b class="black p-1">Всего работ: ${countInGROUP}</b>`;
            countInGROUP = 0;
          }

          nomIDBefore = item.nominationOrder;
          HTMLBODY += `<div class="m-0 p-1 w-100 row">
                        <h4 class="nameNomination p-3  mt-3 mlr-auto txt-al-center">${item.nomination}</h4> 
                        <button name="exportPDF"  class="btn p-1 mt-auto mb-auto ml-1 mr-0 tn_exportPDF " style="color:black" nominationID=${nomIDBefore}>PDF</button>
                      </div>`;
          HTMLBODY += `
          <div class="reference-header firstRow">
              <div class="reference-column">№</div>
              <div class="reference-column">Название работы + ваша личная оценка</div>
              <div class="reference-column " style="max-width: 20%; min-width: 20%;">Последняя заметка</div>
              <div class="reference-column " style="max-width: 20%; min-width: 20%;">Последнее сообщение</div>
          </div>
          `;
        }
        if(typeSort.value == 5 && (competitionBefore!= item.competitionType)){
          competitionBefore = item.competitionType;
          
          if (countInGROUP > 0){
            HTMLBODY += `<b class="black">Всего работ: ${countInGROUP}</b>`;
            countInGROUP = 0;
          }
          // ++countInGROUP;


          HTMLBODY += `<div class="m-0 p-1 w-100 row">
                        <h4 class="nameNomination p-3  mt-3 mlr-auto txt-al-center">${ competitionBefore ? tools.getNameTypePrograms(competitionBefore) : ( competitionBefore === 0 ? tools.getNameTypePrograms(0) : ' - - - ')}</h4> 
                        <button name="exportPDF"  class="btn p-1 mt-auto mb-auto ml-1 mr-0 tn_exportPDF " style="color:black" competitionID=${competitionBefore}>PDF</button>
                      </div>`;

          HTMLBODY += `
          <div class="reference-header firstRow">
              <div class="reference-column">№</div>
              <div class="reference-column">Название работы + ваша личная оценка</div>
              <div class="reference-column " style="max-width: 20%; min-width: 20%;">Последняя заметка</div>
              <div class="reference-column " style="max-width: 20%; min-width: 20%;">Последнее сообщение</div>
          </div>
          `;
        }

        ++countInGROUP;
        HTMLBODY += this.getElement(item, index, newMsg, newCmt, curUserReviewer, countUserReviewer, newVideo);
      });

      if (typeSort.value == 5 || typeSort.value == 4){
          HTMLBODY += `<b class="black">Всего работ: ${countInGROUP}</b>`;
      }

     HTMLBODY += `<div class="column w-100">
                    <div class="cloudTipCenter mt-3">
                      <b class="m-3 txt-al-center">Инструкция</b>
                      <ul>
                        <li>Если вы уполномочены оценивать работы, то зажмите <b>shift</b> и нажатие на облако <b>с текущей оценкой</b>, это поменяет вашу <b>оценку </b>на следующую.</li>
                        <li>Если вы уполномочены отправлять сообщения, то зажмите <b>shift</b> и нажмите на облако  <b> с последним сообщением</b>, чтобы отправить <b>экспресс-сообщение в чат</b>.</li>
                        <li>Если вы уполномочены отправлять сообщения, то зажмите <b>command / windows </b>и нажмите столбец <b>"последнее сообщение"</b>, чтобы добавить заявителя в<b> массовую рассылку</b>.</li>
                      </ul>
                    </div>
              </div>`;

      listPointsBody.innerHTML = HTMLBODY;


    //Ручное добавление всплывающих подсказок

      const date = new Date();
      const curTimeZone = (date.getTimezoneOffset())/60 * -1;

      let allPopUpListenerClass = listPointsBody.querySelectorAll('.popup');
      allPopUpListenerClass.forEach((buttonItem) => {
        if (buttonItem.attributes.popupAlert) {
          buttonItem.addEventListener("mouseover", (evt) => {
            mypopup.querySelector('b').innerHTML = ''; 
            // mypopup.querySelector('div').style.display = 'block';

            if (evt.target.attributes.popupAlert)
              mypopup.querySelector('b').innerHTML = evt.target.attributes.popupAlert.nodeValue;

            if (evt.target.attributes.popupMsg) {
              mypopup.querySelector('div').style.display = 'block';

              if(evt.target.attributes.popupMsg.nodeValue.length == 19)
                mypopup.querySelector('div').innerHTML = tools.dateStringFullAddTimeZone(evt.target.attributes.popupMsg.nodeValue, curTimeZone);
              else
                  mypopup.querySelector('div').innerHTML = evt.target.attributes.popupMsg.nodeValue;
            }
            else{

              mypopup.querySelector('div').style.display = 'none';
              mypopup.querySelector('div').innerHTML = '';
            }
            

            let iconPos = evt.target.getBoundingClientRect();
            let shift = 0;

            if(evt.target.attributes.popupShift)
              shift = evt.target.attributes.popupShift.nodeValue;

              mypopup.style.left = (iconPos.right - 64 - shift) + "px";


            mypopup.style.top = (window.scrollY + iconPos.top + 30) + "px";
            mypopup.style.display = "block";
          });
          buttonItem.addEventListener("mouseout", ()=> {
            mypopup.style.display = "none";
          });
        }
      });

    } else
      listPointsBody.innerHTML = 'Данных пока нет';
  },


  drawMarkupInContainer(markup) {
    listPointsBody.insertAdjacentHTML('beforeend', markup);
  },

};
